import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import RedirectItem from 'common/Widgets/RedirectItem/RedirectItem';

const PopupBackdrop = ({ className = '', onClick, redirect }) => {
  const popupBackgroundClassName = cx('popup-backdrop', className);

  return redirect ? (
    <RedirectItem>
      <div className={popupBackgroundClassName} onClick={onClick} />
    </RedirectItem>
  ) : (
    <div className={popupBackgroundClassName} onClick={onClick} />
  );
};

PopupBackdrop.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  redirect: PropTypes.bool,
};

export default PopupBackdrop;
